export default __webpack_public_path__ + "static/media/LogoASI.12f3debe.png";